import React, { createContext, useContext, useEffect, useState } from 'react';
import { AgendaClienteService } from './Service';
import { Agendamento } from '../Enum';
import { useAuthContext } from '../../../contexts/AuthContext';
import { WebSocketManager } from '../../../WebSocketConfig';
import { FilaEsperaService } from '../../fila-espera/Service';
const agendaService = new AgendaClienteService();
const filaEsperaService = new FilaEsperaService();

interface AgendaClienteParams {
    loading: boolean;
    agendamentos: Agendamento[];
    loadAgendamentos: () => void;
    waitlist: WaitlistEntry[];
    loadWaitlist: () => void;
}

export interface WaitlistEntry {
    timezone?: string;
    _id: string;
    status: string;
    servico?: { _id: string; name: string } | null;
    servicosExtras?: { _id: string; name: string }[] | null;
    servicosExtrasIds?: string[];
    attendant?: { uid: string; name: string } | null;
    preferredStartAt?: string | Date;
    preferredEndAt?: string | Date;
    timeWindowStartMinutes?: number;
    timeWindowEndMinutes?: number;
    offerExpiresAt?: string | Date;
    createdAt?: string | Date;
}

const AgendaClienteContext = createContext<AgendaClienteParams | undefined>(undefined);

export const useAgendaClienteContext = () => {
    const context = useContext(AgendaClienteContext);
    if (!context) {
        throw new Error('useAgendaClienteContext must be used within an AgendaClienteContext');
    }
    return context;
};

export const AgendaClienteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user } = useAuthContext();
    const [loading, setLoading] = useState(true);
    // A separacao entre proximos e historico e feita na lista (abas), sem filtro no contexto.
    const [agendamentos, setAgendamentos] = useState<Agendamento[]>([]);
    const [waitlist, setWaitlist] = useState<WaitlistEntry[]>([]);

    const loadAgendamentos = async () => {
        try {
            const { data } = await agendaService.getAgendamentosCards();

            setAgendamentos(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error fetching agendamentos:', error);
        } finally {
            setLoading(false);
        }
    };

    const loadWaitlist = async () => {
        try {
            const { data } = await filaEsperaService.findAllCliente();
            setWaitlist(data || []);
        } catch (error) {
            console.error('Error fetching fila de espera:', error);
        }
    };

    useEffect(() => {
        loadAgendamentos();
        loadWaitlist();
    }, []);

    useEffect(() => {
        if (!user?.uid) return;

        const webSocketManager = new WebSocketManager();
        webSocketManager.onReady(() => {
            webSocketManager.onChannel(`horarios:cliente`, () => {
                loadAgendamentos();
            });
            webSocketManager.onChannel(`fila-espera:cliente`, () => {
                loadWaitlist();
            });
        });

        return () => {
            webSocketManager.disconnect();
        };
    }, [user?.uid]);

    return (
        <AgendaClienteContext.Provider
            value={{
                loading,
                agendamentos,
                loadAgendamentos,
                waitlist,
                loadWaitlist,
            }}
        >
            {children}
        </AgendaClienteContext.Provider>
    );
};
